import React from "react";
import {
  Image,
  ImageBackground,
  ImageStyle,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
  ViewStyle,
  useWindowDimensions,
} from "react-native";
import { DrawerContentScrollView } from "@react-navigation/drawer";
import * as FileSystem from "expo-file-system";
import {
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  Octicons,
  SimpleLineIcons,
} from "@expo/vector-icons";
import {
  Badge,
  BadgeText,
  Button,
  ButtonIcon,
  ButtonText,
  HStack,
  VStack,
} from "@gluestack-ui/themed";

import { customApp } from "../config";
import { useStores } from "../models";
import * as Storage from "../utils/storage";
import { onPatch } from "mobx-state-tree";
import { glueStyles } from "../configGlueStack/gluestack-ui.config";


export const SideMenu = (props: any) => {
  const { authenticationStore, formsStore, tasksStore, itemsStore } = useStores();
  const dimensions = useWindowDimensions();
  const [expandForms, setExpandForms] = React.useState<string | undefined>(undefined);
  const [rendered, setRender] = React.useState(<></>);
  const [mustSync, setMustSync] = React.useState<boolean>(false);

  const renderMe = () => {
    const isFieldForms = customApp.user && customApp.user !== "";
    const logo_background = require("../../assets/images/blurred_linesDark.png");
    const route = props.navigation.getState();
    const user = authenticationStore.userInfo.user;
    const mySubscriptions = formsStore.mySubscriptions();
    const subscriptions = JSON.parse(
      JSON.stringify(mySubscriptions.subscriptions)
    ).sort((a: any, b: any) => a.name.localeCompare(b.name));

    const source = user.hasProfile
      ? {
          uri:
            Platform.OS === "web" || true
              ? user.profileUrl
              : `file://${FileSystem.documentDirectory}/profile-${authenticationStore.userIdLogged}.jpg?${Date.now()}`,
        }
      : require("../../assets/images/logo_circle.png");

    const workflow_count = { simple: 0, ptw: 0 };

    const checkMustSync = async () => {
      const syncVal = await Storage.getItem("must_sync");
      setMustSync(syncVal !== undefined);
    };

    itemsStore.myItems().reduce((_state: any, _item: any) => {
      if (_item.statusPTW && _item.status === "draft") {
        if (
          subscriptions.find(
            (dept: any) =>
              dept.id === _item.deptId &&
              dept.forms.find((f: any) => f.id === _item.formId)?.type === "workflow"
          )
        ) {
          _state.simple += 1;
        } else {
          _state.ptw += 1;
        }
      }
      return _state;
    }, workflow_count);

    const depts = subscriptions.reduce((_depts: any[], _d: any) => {
      _d.forms = _d.forms.reduce((_forms: any[], _f: any) => {
        if (_f.type === undefined) _forms.push(_f);
        return _forms;
      }, []);
      if (_d.forms.length > 0) _depts.push(_d);
      return _depts;
    }, []);

    const activeRouteName = route.routes[route.index]?.name;
    const activeRouteParams = route.routes[route.index]?.params || {};

    return (
      <View style={{ flex: 1, maxHeight: dimensions.height }}>
        {/* Header Profile Section */}
        <View style={$logoContainer}>
          <ImageBackground source={logo_background} style={$userBackImage}>
            <VStack style={{ width: "100%" }}>
              <HStack alignItems="center" style={{ width: "100%", paddingHorizontal: 10 }}>
                <Image alt="useravatar" source={source} style={$userImage} />
                <Pressable
                  onPress={() => props.navigation.navigate("Settings", { fromForm: false })}
                  style={{ paddingBottom: 10, flex: 1, maxWidth: 200 }}
                >
                  <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                    <MaterialIcons name="person" size={18} color="#fff" style={{ marginRight: 4 }} />
                    <Text numberOfLines={1} ellipsizeMode="tail" style={styles.userNameText}>
                      {user?.firstName} {user?.lastName}
                    </Text>
                  </View>
                  <Text numberOfLines={1} ellipsizeMode="tail" style={styles.userEmailText}>
                    {customApp.profileHidden ? null : user?.email}
                  </Text>
                </Pressable>
              </HStack>
            </VStack>
          </ImageBackground>
        </View>

        {/* Menu Items Container */}
        <View style={{ marginVertical: 0, flex: 4 }}>
          {/* Top Quick Actions Bar */}
          <HStack
            style={{
              borderBottomWidth: 1,
              borderBottomColor: "#CBD5E1",
              paddingHorizontal: 12,
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Pressable
              onPress={async () => {
                Storage.removeItem("must_sync");
                await itemsStore.upload({});
                formsStore.getSubscriptions();
                checkMustSync();
              }}
            >
              <HStack space="xs" style={{ paddingLeft: 4, paddingVertical: 8, alignItems: "center" }}>
                <MaterialCommunityIcons name="cloud-sync-outline" size={20} color={glueStyles.colors.closed400} />
                <Text style={styles.actionText}>Sincronizar</Text>
                {mustSync && (
                  <Badge
                    size="sm"
                    action="warning"
                    variant="solid"
                    style={{ borderRadius: 9999, marginBottom: -5, marginLeft: 2 }}
                  >
                    <BadgeText style={{ fontSize: 10 }}>!</BadgeText>
                  </Badge>
                )}
              </HStack>
            </Pressable>

            <View style={{ width: 1, height: "60%", backgroundColor: "#CBD5E1" }} />

            <Pressable
              onPress={() => {
                props.navigation.navigate("Settings");
                setRender(renderMe());
              }}
            >
              <HStack space="xs" style={{ paddingLeft: 4, paddingVertical: 8, alignItems: "center" }}>
                <Ionicons name="person" size={18} color={glueStyles.colors.closed400} />
                <Text style={styles.actionText}>Configuraciones</Text>
              </HStack>
            </Pressable>
          </HStack>

          {/* Drawer Navigation List */}
          <DrawerContentScrollView
            style={{ flex: 1 }}
            contentContainerStyle={{ paddingTop: 0 }}
            safeAreaInsets={{ top: 0, bottom: 0 }}
            {...props}
          >
            <View style={{ paddingLeft: 12, paddingRight: 0, paddingVertical: 0 }}>
              {/* Tareas Link */}
              <Pressable
                onPress={() => {
                  props.navigation.navigate("TasksList");
                  setRender(renderMe());
                }}
              >
                <HStack
                  space="md"
                  alignItems="center"
                  style={[
                    styles.menuRow,
                    activeRouteName === "TasksList" && styles.activeBorder,
                  ]}
                >
                  <Ionicons name="calendar-outline" size={16} color={glueStyles.colors.closed400} />
                  <Text style={styles.menuTextBold}>Tareas</Text>
                </HStack>
              </Pressable>

              {/* Flujos de trabajo Link */}
              <Pressable
                onPress={() => {
                  props.navigation.navigate("WFHome");
                  setRender(renderMe());
                }}
              >
                <HStack
                  space="md"
                  alignItems="center"
                  style={[
                    styles.menuRow,
                    activeRouteName === "WFHome" && styles.activeBorder,
                  ]}
                >
                  <Octicons name="workflow" size={16} color={glueStyles.colors.closed400} />
                  <Text style={[styles.menuTextBold, { flex: 1 }]}>Flujos de trabajo</Text>
                  {workflow_count?.simple > 0 && (
                    <Badge action="error" variant="solid" style={styles.counterBadge}>
                      <BadgeText style={{ color: "white", fontSize: 12 }}>
                        {workflow_count.simple}
                      </BadgeText>
                    </Badge>
                  )}
                </HStack>
              </Pressable>

              {/* Permisos de Trabajo Link */}
              <Pressable
                onPress={() => {
                  props.navigation.navigate("PTWHome");
                  setRender(renderMe());
                }}
              >
                <HStack
                  space="md"
                  alignItems="center"
                  style={[
                    styles.menuRow,
                    activeRouteName === "PTWHome" && styles.activeBorder,
                  ]}
                >
                  <MaterialCommunityIcons
                    name="order-bool-descending-variant"
                    size={16}
                    color={glueStyles.colors.closed400}
                  />
                  <Text style={[styles.menuTextBold, { flex: 1 }]}>Permisos de Trabajo</Text>
                  {workflow_count?.ptw > 0 && (
                    <Badge action="error" variant="solid" style={styles.counterBadge}>
                      <BadgeText style={{ color: "white", fontSize: 12 }}>
                        {workflow_count?.ptw}
                      </BadgeText>
                    </Badge>
                  )}
                </HStack>
              </Pressable>
            </View>

            {/* Subtitle Section */}
            <View style={styles.sectionHeaderContainer}>
              <Text style={styles.sectionHeaderText}>Departamentos</Text>
            </View>

            {/* Departments & Forms Tree */}
            <View style={{ paddingLeft: 10, paddingRight: 5 }}>
              {depts.map((dept: any) => {
                const isDeptActive =
                  ["FormsList", "ItemsList", "ItemDetails"].includes(activeRouteName) &&
                  activeRouteParams.deptId === dept.id;

                return (
                  <View key={dept.id}>
                    <Pressable
                      style={{ paddingVertical: 8 }}
                      onPress={() => {
                        props.navigation.navigate("FormsList", { deptId: dept.id });
                        setRender(renderMe());
                      }}
                    >
                      <HStack
                        space="xs"
                        alignItems="center"
                        style={[isDeptActive && styles.activeBorder]}
                      >
                        <Pressable
                          hitSlop={10}
                          onPress={() =>
                            setExpandForms(expandForms === dept.id ? undefined : dept.id)
                          }
                          style={{ padding: 4 }}
                        >
                          <Ionicons
                            name={expandForms === dept.id ? "caret-down" : "caret-forward"}
                            size={18}
                            color={customApp.styles.primaryColor}
                          />
                        </Pressable>
                        <Text style={[styles.menuTextBold, { width: "70%" }]} numberOfLines={1}>
                          {dept.name}
                        </Text>
                        <View style={{ flex: 1 }} />
                        <Badge action="info" variant="solid" style={styles.counterBadge}>
                          <BadgeText style={{ color: "white", fontSize: 12 }}>
                            {dept.forms?.length}
                          </BadgeText>
                        </Badge>
                      </HStack>
                    </Pressable>

                    {/* Collapsible Forms Submenu */}
                    {expandForms === dept.id && (
                      <VStack>
                        {dept.forms
                          .sort((a: any, b: any) => a.name.localeCompare(b.name))
                          .map((form: any) => {
                            const isFormActive =
                              ["ItemsList", "ItemDetails"].includes(activeRouteName) &&
                              activeRouteParams.formId === form.id;

                            return (
                              <View key={form.id}>
                                <Pressable
                                  style={{ paddingVertical: 8 }}
                                  onPress={() => {
                                    props.navigation.navigate(
                                      form.type
                                        ? form.type === "workflow"
                                          ? "WFHome"
                                          : "PTWHome"
                                        : "ItemsList",
                                      form.type
                                        ? { rnd: 1 }
                                        : { deptId: dept.id, formId: form.id, forReview: false }
                                    );
                                    setRender(renderMe());
                                  }}
                                >
                                  <HStack
                                    alignItems="center"
                                    style={[
                                      { marginLeft: 25 },
                                      isFormActive && styles.activeBorder,
                                    ]}
                                  >
                                    <MaterialCommunityIcons
                                      name={isFormActive ? "format-list-checks" : ""}
                                      size={18}
                                      color={customApp.styles.primaryColor}
                                      style={{ marginRight: activeRouteParams.formId === form.id ? 4 : 0 }}
                                    />
                                    <Text style={styles.subFormText} numberOfLines={1}>
                                      {form.name}
                                    </Text>
                                  </HStack>
                                </Pressable>
                              </View>
                            );
                          })}
                      </VStack>
                    )}
                  </View>
                );
              })}
            </View>
          </DrawerContentScrollView>
        </View>

        {/* Sign Out Button */}
        {!isFieldForms && (
          <Button 
            bgColor={glueStyles.colors.danger400}
            variant="solid"
            style={{ margin: 0, marginTop: 5,borderRadius:0 }}
            onPress={() => authenticationStore.signOut()}
          >
            <ButtonIcon as={SimpleLineIcons} name="logout" size="sm" mr="$2" />
            <ButtonText>Cerrar Sesion</ButtonText>
          </Button>
        )}

        {/* Footer Bar */}
        <HStack
          style={{
            backgroundColor: "black",
            width: "100%",
            paddingHorizontal: 8,
            paddingVertical: 4,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Text style={{ color: "white", fontSize: 10 }}>{customApp.version}</Text>
          <Text style={{ color: "white", fontSize: 10 }}>
            ult. sinc.: {new Date(mySubscriptions.lastSync).getYYYYMMddHHmmss()}
          </Text>
        </HStack>
      </View>
    );
  };

  React.useEffect(() => {
    setRender(renderMe());
    const _disposerOnPatch = onPatch(formsStore, (patch) => {
      if (
        (patch.op === "replace" && patch.path.includes("/lastSync")) ||
        (patch.op === "add" &&
          patch.path.includes("/subscriptionsByUsersDB/") &&
          patch.value?.lastSync !== undefined)
      ) {
        setTimeout(() => setRender(renderMe()), 300);
      }
    });
    return () => {
      _disposerOnPatch();
    };
  }, []);

  React.useEffect(() => {
    setRender(renderMe());
  }, [expandForms]);

  return rendered;
};

/* Styles Sheet */
const $userImage: ImageStyle = {
  width: 80,
  height: 80,
  marginVertical: 10,
  borderRadius: 40,
};

const $logoContainer: ViewStyle = {
  flex: 2,
  alignItems: "center",
  maxHeight: 100,
};

const $userBackImage: ImageStyle = {
  flex: 1,
  width: "100%",
  maxHeight: 100,
  justifyContent: "center",
  alignItems: "center",
};

const styles = StyleSheet.create({
  userNameText: {
    color: "#ffffff",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 14,
  },
  userEmailText: {
    color: "#ffffff",
    textAlign: "center",
    fontSize: 12,
  },
  actionText: {
    fontSize: 14,
    color: "#334155",
  },
  menuRow: {
    paddingLeft: 10,
    paddingRight: 5,
    marginVertical: 10,
  },
  menuTextBold: {
    fontWeight: "bold",
    color: "#1E293B",
    fontSize: 14,
  },
  subFormText: {
    fontSize: 12,
    color: "#334155",
    width: "100%",
  },
  counterBadge: {
    height: 25,
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 8,
  },
  activeBorder: {
    borderBottomWidth: 2,
    borderBottomColor: customApp.styles.secondaryColor,
  },
  sectionHeaderContainer: {
    backgroundColor: "#F1F5F9",
    padding: 12,
  },
  sectionHeaderText: {
    color: customApp.styles.secondaryColor,
    fontSize: 16,
    fontWeight: "500",
  },
});